import dotProp from 'dot-prop'

/**
 *
 * @param {Array<Object>} arr - List of objects.
 * @param {String} keyPath - The keypath to key off of, e.g. 'id'.
 * @return {Object<String, Object>} - An object keyed off the primary value.
 */
export default (arr, keyPath) => arr
    .reduce((map, obj) => {
        map[dotProp.get(obj, keyPath)] = obj
        return map
    }, {})
